module.exports = __webpack_public_path__ + "static/media/tech.1c2ed8b5.jpg";